"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "@/i18n/navigation";
import { Heading1, Button, BoldText, Callout, HRuler, BackLink, PageAlerts } from "@ops-gsic/cxp-component-library-react";
import ExpanderInfoSection from "./ExpanderInfoSection";
import ClockIcon from "@/assets/icons/ontario-icon-clock.svg";
import DurationSpan, { BackLinkWrapper, ButtonContainer, CalloutContent, TextParagraphLg } from "./styles";
import MainInfoSection from "./MainInfoSection";
import { useSession } from "next-auth/react";
import { PageWrapper } from "@/components/page-wrapper";
import { ROUTES } from "@/constants";
import { useSearchParams } from "next/navigation";
import { SectionWrapper } from "@/styles";
export default function Home() {
  const $ = _c(54);
  const t = useTranslations("HomePage");
  const tCommon = useTranslations("Common");
  const {
    status
  } = useSession();
  const router = useRouter();
  const locale = useLocale();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("message");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const message = t0;
  let t1;
  if ($[2] !== message || $[3] !== t) {
    t1 = () => {
      if (message) {
        return <PageAlerts alertType="success" heading={t(`information.message.${message}.heading`)} />;
      }
    };
    $[2] = message;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const renderMessage = t1;
  let t2;
  if ($[5] !== router) {
    t2 = () => {
      router.push(ROUTES.ELIGIBILITY);
    };
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onContinue = t2;
  const t3 = status !== "authenticated";
  let t4;
  if ($[7] !== locale || $[8] !== status || $[9] !== tCommon) {
    t4 = <BackLinkWrapper>{status === "authenticated" ? <BackLink href={`/web${locale === "fr" ? "/fr" : ""}/dashboard`} text={tCommon("backToHome")} /> : <BackLink href={tCommon("serviceOntarioSP")} text={tCommon("backToOntarioCa")} />}</BackLinkWrapper>;
    $[7] = locale;
    $[8] = status;
    $[9] = tCommon;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HRuler />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== message || $[13] !== renderMessage) {
    t6 = message && renderMessage();
    $[12] = message;
    $[13] = renderMessage;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("information.heading1");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <Heading1>{t7}</Heading1>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ClockIcon aria-hidden="true" focusable="false" />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("information.timeEstimate.info");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("information.timeEstimate.time");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <BoldText> {t11}</BoldText>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("information.timeEstimate.unit");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <DurationSpan>{t12}{t13}</DurationSpan>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t14) {
    t15 = <Callout type="callout"><CalloutContent>{t9}{t10}{t14}</CalloutContent></Callout>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("information.onlineProcess");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <TextParagraphLg>{t16}</TextParagraphLg>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <HRuler />;
    t19 = <MainInfoSection />;
    $[38] = t18;
    $[39] = t19;
  } else {
    t18 = $[38];
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <SectionWrapper><ExpanderInfoSection /></SectionWrapper>;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== tCommon) {
    t21 = tCommon("continue");
    $[41] = tCommon;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== onContinue || $[44] !== t21) {
    t22 = <ButtonContainer><Button onClick={onContinue}>{t21} </Button></ButtonContainer>;
    $[43] = onContinue;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t15 || $[47] !== t17 || $[48] !== t22 || $[49] !== t3 || $[50] !== t4 || $[51] !== t6 || $[52] !== t8) {
    t23 = <PageWrapper showCreateAccountBanner={t3}>{t4}{t5}{t6}{t8}{t15}{t17}{t18}{t19}{t20}{t22}</PageWrapper>;
    $[46] = t15;
    $[47] = t17;
    $[48] = t22;
    $[49] = t3;
    $[50] = t4;
    $[51] = t6;
    $[52] = t8;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  return t23;
}